import React from "react";
import { cn } from "tailwind-variants";
import Loader from "common/vue/components/Loader.react.vue";
import { useDtfStore } from "./store";
import "./ArtworkHistoryModalFooter.scss";

export default function ArtworkHistoryModalFooter({
  count,
  isLoadingCta,
  ctaText,
  onClose,
  onCtaAction,
  ...restProps
}) {
  const store = useDtfStore();

  function isStandardArtwork() {
    return store.isStandardArtwork;
  }

  return (
    <div
      {...restProps}
      className={cn("artwork-history-footer scope-18004666", restProps.className)}
    >
      <span className="artwork-history-footer__count scope-18004666">{count}</span>
      <div className="artwork-history-footer__button-container scope-18004666">
        <button
          className={cn(
            "artwork-history-footer__button artwork-history-footer__button--secondary scope-18004666",
            {
              "artwork-history-footer__button--standard-artwork": isStandardArtwork()
            }
          )}
          type="button"
          onClick={onClose}
          data-testid="artwork-history-footer-button"
        >
          {" "}
          Cancel{" "}
        </button>
        <button
          className={cn(
            "artwork-history-footer__button artwork-history-footer__button--primary scope-18004666",
            {
              "artwork-history-footer__button--loading": isLoadingCta,
              "artwork-history-footer__button--standard-artwork": isStandardArtwork()
            }
          )}
          type="button"
          disabled={isLoadingCta}
          onClick={onCtaAction}
          data-testid="artwork-history-footer-button-1"
        >
          {ctaText}{" "}
          {isLoadingCta ? (
            <Loader
              className="artwork-history-footer__loader scope-18004666"
              data-testid="artwork-history-footer-loader"
            />
          ) : null}
        </button>
      </div>
    </div>
  );
}
